<template>
  <GraphStatistics>
    <template slot="title">
      {{ $t("management.staticticsByDocumentsUploaded") }}
    </template>
    <template slot="excel">
      <a
        @click="downExcel()"
        href="javascript:void(0)"
        class="btn btn-secondary btn-md m-1"
        >{{ $t("common.excelDownload") }}</a
      >
    </template>
    <template slot="filter">
      <tr>
        <th>{{ $t("common.year") }}</th>
        <td>
          <select
            class="int_type01 mgt_seltype int_w_full selectInput"
            v-model="form.year"
            @change="setStatistics"
          >
            <option v-for="(year, index) in setUp.yearList" :key="index">
              {{ year }}
            </option>
          </select>
        </td>
        <th>{{ $t("management.documentType") }}</th>
        <td>
          <select
            class="int_type01 mgt_seltype int_w_full selectInput"
            v-model="form.firstDoctype"
            @change="setStatistics"
          >
            <option value="total">ALL</option>
            <option
              v-for="(firstDoctype, index) in setUp.firstDoctypeList"
              :key="index"
              :value="firstDoctype.doctypeId"
            >
              {{ firstDoctype.doctypeName }}
            </option>
          </select>
        </td>
      </tr>
    </template>
    <template slot="graph">
      <ChartTemplate id="chartTemplate" ref="chartTemplate" />
    </template>
  </GraphStatistics>
</template>

<script>
import GraphStatistics from "@/components/management/statistics/common/GraphStatistics";
import { getFirstDoctypeList } from "@/api/doctype";
import ChartTemplate from "@/components/management/statistics/doctype/ChartTemplate";
import { docTypeStatisticsExcel } from "@/api/statistics";
export default {
  components: {
    ChartTemplate,
    GraphStatistics,
  },
  data() {
    return {
      setUp: {
        yearList: [],
        firstDoctypeList: [],
      },
      form: {
        year: "",
        firstDoctype: "",
      },
    };
  },
  async created() {
    await this.setting();
  },
  methods: {
    async setting() {
      this.setYearSelect();
      await this.setFirstDoctype();
      this.setStatistics();
    },
    setYearSelect() {
      var firstYear = 2021;
      var now = new Date();
      var lastYear = now.getFullYear();
      this.form.year = lastYear;

      var yearList = [];
      for (lastYear; lastYear >= firstYear; lastYear--) {
        yearList.push(lastYear);
      }
      this.setUp.yearList = yearList;
    },
    async setFirstDoctype() {
      const response = await getFirstDoctypeList();
      console.log(response);
      this.setUp.firstDoctypeList = response.data.firstDoctypeList;
      this.form.firstDoctype = "total";
    },
    async setStatistics() {
      await this.$refs.chartTemplate.getData(this.form.year, this.form.firstDoctype);
    },
    async downExcel() {
      let loader = this.$loading.show({});
      let result = await docTypeStatisticsExcel(this.form.year, this.form.firstDoctype);
      const url = window.URL.createObjectURL(
        new Blob([result.data], { type: result.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.download = "StaticticsBy_DocumentsUploaded.xls";
      link.click();
      window.URL.revokeObjectURL(url);
      loader.hide();
    },
  },
};
</script>

<style></style>
